// extracted by mini-css-extract-plugin
module.exports = {"registration_btn":"Registration_registration_btn__rs7a7"};